(function () {
  'use strict';

  angular
    .module('trainingAuditReport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('trainingAuditReport', {
        url: '/training-audit-report',
        views: {
          'trainingAuditReportView': {
            templateUrl: 'training-audit-report/views/training-audit-report.tpl.html',
            controller: 'TrainingAuditReportCtrl',
            controllerAs: 'trainingAuditReport'
          }
        }
      });
  }
}());
